module.exports = {
  channelName: '渠道名称',
  simQueryPlaceholder: '请输入渠道名称',
  shippingType: '运输方式',
  destinationDistribution: '目的地配送方式',
  chargingMethod: '计费方式',
  acceptableGoods: '可接货物',
  settlementWeightRoundingRules: '结算重量进位规则',
  creator: '创建人',
  bubbleCountingRatio: '计泡系数',
  bubbleSplittingRatio: '分泡比例',
  multipleBoxesCalculationRules: '多箱计算规则',
  singleBoxLowestBillableWeight: '单箱最低计费重量',
  newChannel: '新增渠道',
  editChannel: '编辑渠道',
  lookChannel: '查看渠道',
  weightInfo: '计重信息',
  channelNameNoEmpty: '渠道名称不能为空！',
  shippingTypeNoEmpty: '运输方式不能为空！',
  destinationDistributionNoEmpty: '目的地配送方式不能为空！',
  chargingMethodNoEmpty: '计费方式不能为空！',
  bubbleCountingRatioNoEmpty: '计泡系数不能为空！',
  bubbleSplittingRatioNoEmpty: '分泡比例不能为空！',
  singleBoxLowestBillableWeightNoEmpty: '单箱最低计费重量不能为空！',
  multipleBoxesCalculationRulesNoEmpty: '多箱计算规则不能为空！',
  settlementWeightRoundingRulesNoEmpty: '结算重量进位规则不能为空！',
  acceptableGoodsNoEmpty: '至少选择一项可接货物！',
  editExistChannel: '渠道已生成报价单，是否刷新报价单渠道相关信息？',
  notEditName: '该渠道已被引入报价单，不能修改渠道名称。',
  activeState: '启用状态',
  enable: '启用',
  disable: '禁用',
  enableSucceed: '渠道启用成功！',
  disableSucceed: '渠道禁用成功！',
  cannotActive: '没有数据可修改。',
  exportQuotation: '导出报价单',
  printQuotation: '打印报价单',
  quotationValidityPeriod: '报价有效期',
  quotationLabel: '报价标签',
  previewQuotation: '预览报价',
  longTerm: '长期有效',
  addOrder: '新增下单',
  revokeTheApprovalForm: '撤销核单',
  revokeOutboundShipment: '撤销出库',
  containerNo: '集装箱号',
  cannotDelete: '不允许删除已经生成报价单的渠道！'
}
